import { View, Dimensions, ActivityIndicator, Text } from 'react-native';

let ww = Dimensions.get('window').width;
let hh = Dimensions.get('window').height;

let scr = ww;
let landscape = ww > hh;
if (ww > hh) scr = hh;

const vp = scr / 100;
const vps = (s) => {
  if (s >= 100) return scr;
  return Math.floor(vp * s);
}

export default {
  vp,
  vps,
  landscape
};

